import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('select[data-t-meteo-stations]', () => {
  void import('./internal/t_meteo_form').then(({ initTMeteoForm }) => initTMeteoForm());
});

onElelementExistRunOnce('.weather_stations_index_page', () => {
  void import('./internal/index-page').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('#weather_station_map', () => {
  void import('./internal/weather-station-map').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('#wmo_weather_station_map', () => {
  void import('./internal/wmo-weather-station-map').then(({ default: Component }) => Component());
});
